<template>
    <div class="login-overlay">
        <div class="login-box">
        <img alt="Vue logo" src="../assets/image/logo.png" style="width: 35%;">
        <form @submit.prevent="onFormSubmit">
            <input v-model="contacts.username" name="username" placeholder="Username" required />
            <input v-model="contacts.password" type="password" name="password" placeholder="Password" required />
            <p v-if="errors" style="color: red;">Nom d'utilisateur ou mot de passe incorrect</p>
            <button type="submit">Se connecter</button>
        </form>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            errors: false,
            contacts: {
                username: '',
                password: '',
            },
        };
    },
    methods: {
        async onFormSubmit() {
            try {
                await this.$store.dispatch('login', this.contacts);
                this.$emit('authenticated'); // avertit le parent
            } catch {
                this.errors = true;
            }
        },
    },
};
</script>

<style scoped>
    .login-overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .login-box {
        width: 350px;
        padding: 30px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 0 15px rgba(0,0,0,0.5);
        text-align: center;
    }

    input {
        width: 80%;
        margin: 10px auto;
        padding: 12px;
        border-radius: 5px;
        border: 1px solid #ccc;
        display: block;
    }

    button {
        width: 87%;
        padding: 12px;
        background: #167580;
        color: white;
        font-weight: bold;
        border: none;
        border-radius: 5px;
        cursor: pointer;
    }

    button:hover {
        background: #167580;
    }
</style>
